import fetch from 'auth/GenericFetchInterceptor'

const CalendarService = {}

// Keep every related record; the report only reads these fields from each one.
const reportPopulation =
    '&populate[operatore][fields][0]=username' +
    '&populate[patient][populate][visits][fields][0]=data_visita' +
    '&populate[patient][populate][sales_patients][fields][0]=data' +
    '&populate[patient][populate][sales_patients][fields][1]=stato' +
    '&populate[patient][populate][sales_patients][fields][2]=tipologia' +
    '&populate[patient][populate][stores][fields][0]=name' +
    '&populate[patient][populate][state_type_patients][fields][0]=tipo' +
    '&populate[patient][populate][state_type_patients][fields][1]=stato' +
    '&populate[patient][populate][state_type_patients][fields][2]=anno_di_vendita' +
    '&populate[patient][fields][0]=nome' +
    '&populate[patient][fields][1]=cognome' +
    '&populate[patient][fields][2]=audioprotesista' +
    '&populate[patient][fields][3]=nome_provenienza';


/*CalendarService.getUserPuntiVendita = function (path) {
    return fetch({
        url: `/api/users?populate[binding_roles][populate][0]=store${path}&populate=role`,
        method: 'GET'
    })
}*/
CalendarService.getUserPuntiVendita = function () {
    return fetch({
        url: `/api/users?populate[binding_roles][populate][0]=store&populate=role`,
        method: 'GET'
    })
}

CalendarService.getEvents = function (puntivendita, start, end) {

    const queryStringArray = puntivendita.map(store => `&filters[storeLabel]=${store.id}`);
    return fetch({
        url: `/api/calendars?filters[start][$gte]=${start}&filters[end][$lte]=${end}${queryStringArray.join('')}`,
        method: 'GET'
    })
    /*return fetch({
        url: `/api/calendars?populate[patient][fields]=nome&populate[store][fields]=name&populate[operatore][fields]=color${queryStringArray.join('')}&filters[start][$gte]=${start}&filters[end][$lte]=${end}`,
        method: 'GET'
    })*/
}
CalendarService.getReport = function (puntivendita, start, end) {

    const queryStringArray = puntivendita.map(store => `&filters[storeLabel]=${store.id}`);
    /* old spi 
/api/calendars?populate[operatore][populate][0]=role&filters[start][$gte]=${start}&filters[end][$lte]=${end}&filters[stato]=APPUNTAMENTO CONFERMATO&filters[tipo]=appuntamento&populate[patient][populate][0]=visits&populate[patient][populate][1]=sales_patients&populate[patient][populate][2]=stores&populate[patient][fields][0]=nome&populate[patient][fields][1]=cognome&populate[patient][fields][2]=stato_paziente&populate[patient][fields][3]=anno_di_vendita&populate[patient][fields][4]=audioprotesista&populate[patient][fields][5]=stato_paziente&populate[patient][fields][6]=audioprotesista&populate[patient][fields][7]=tipo_provenienza&populate[patient][fields][8]=nome_provenienza&populate[patient][fields][9]=tipo_paziente${queryStringArray.join('')}
    */
    return fetch({
        url: `/api/audiomedical/report-mancanti?sort[0]=start:desc&filters[start][$gte]=${start}&filters[end][$lte]=${end}&filters[stato]=APPUNTAMENTO CONFERMATO&filters[tipo]=appuntamento${reportPopulation}${queryStringArray.join('')}`,
        method: 'GET'
    })

}

CalendarService.getReportPage = function (puntivendita, start, end, page = 1, pageSize = 100, withCount = true) {

    const queryStringArray = puntivendita.map(store => `&filters[storeLabel]=${store.id}`);
    return fetch({
        url: `/api/audiomedical/report-mancanti?sort[0]=start:desc&filters[start][$gte]=${start}&filters[end][$lte]=${end}&filters[stato]=APPUNTAMENTO CONFERMATO&filters[tipo]=appuntamento${reportPopulation}&pagination[pageSize]=${pageSize}&pagination[page]=${page}&pagination[withCount]=${withCount}${queryStringArray.join('')}`,
        method: 'GET'
    })

}
CalendarService.addEvent = function (body) {

    return fetch({
        url: `/api/calendars`,
        method: 'POST',
        data: body
    })
}
CalendarService.editEvent = function (id, body) {

    return fetch({
        url: `/api/calendars/${id}`,
        method: 'PUT',
        data: body
    })
}
CalendarService.deleteEvent = function (id) {

    return fetch({
        url: `/api/calendars/${id}`,
        method: 'DELETE',
    })
}
export default CalendarService;
